export const proposalSolicitor = (solicitors, contactId) => {
  if (!solicitors || !contactId) return {};
  const solicitor = solicitors.find((solicitor) => solicitor.contact_id === contactId);
  return solicitor ? solicitor : {};
};

export const askAmounts = [
  {
    key: 'ORIGINAL',
    date: 'original_ask_date',
    amount: 'original_ask_amount',
    label: 'Original',
  },
  {
    key: 'ASK',
    date: 'ask_date',
    amount: 'ask_amount',
    label: 'Ask',
  },
  {
    key: 'EXPECTED',
    date: 'expected_date',
    amount: 'expected_amount',
    label: 'Expected',
  },
  {
    key: 'FUNDED',
    date: 'funded_date',
    amount: 'funded_amount',
    label: 'Funded',
  },
];

export const INTERACTION_CHARACTER_LIMIT = Object.freeze({
  TEXT: 4294967294,
  DXO_TEXT: 4294967294,
  SUMMARY: 65534,
  PURPOSE: 225,
});

export const PROPOSAL_CHARACTER_LIMIT = Object.freeze({
  DESCRIPTION: 65534,
  TITLE: 190,
  ADDITIONAL_PROPOSAL_CATEGORY: 100,
  PRIMARY_PROPOSAL_UNIT: 225,
});
